export const environment = {
	production: true,
	serverUrl: 'https://cpv-stg-iis02.oem.nycnet:3000'
	// serverUrl: 'https://cpv-iis01.oem.nycnet:3000'
	// serverUrl: 'https://vtran-dev.oem.nycnet:3000'
};
